import { createFileRoute } from "@tanstack/react-router";
import { MeteoPage } from "@/components/meteo-page";

export const Route = createFileRoute("/")({
  head: () => ({ meta: [
  {
    "title": "Meteo \u2013 Flood and heavy rain warnings"
  },
  {
    "name": "description",
    "content": "Meteo warns you in time to act when heavy rain or flooding threatens the places that matter to you."
  },
  {
    "property": "og:title",
    "content": "Meteo \u2013 Flood and heavy rain warnings"
  },
  {
    "property": "og:description",
    "content": "Early flood and heavy rain advisories for your home, work, school and route."
  },
  {
    "property": "og:type",
    "content": "website"
  },
  {
    "name": "twitter:card",
    "content": "summary_large_image"
  },
  {
    "property": "og:image",
    "content": "/images/meteo-0.jpg"
  },
  {
    "name": "twitter:image",
    "content": "/images/meteo-0.jpg"
  }
] }),
  component: MeteoPage,
});
